<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12" md="3" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            label="Name"
                                            v-model="$v.editedItem.name.$model"
                                            :error-messages="nameError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            label="Guardian Name"
                                            v-model="$v.editedItem.guardian_name.$model"
                                            :error-messages="guardianNameError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            label="Family Name"
                                            v-model="$v.editedItem.family_name.$model"
                                            :error-messages="lastNameError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" pa-1 ma-1>
                                    <datePicker  :errorFn = "dobError"
                                                 labelProp="DOB"
                                                 :valueProp="editedItem.birthdate"
                                                 @dateValue="$v.editedItem.birthdate.$model = $event"
                                    ></datePicker>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            v-model="$v.address.address_line_1.$model"
                                            label="Address"
                                            :error-messages="addressError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            v-model="$v.address.address_line_2.$model"
                                            label="Apt #"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            v-model="$v.address.city.$model"
                                            label="City"
                                            :error-messages="addressCityError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" pa-1 ma-1>
                                    <usStatesSelect
                                            :state="address.state"
                                            :error-fn="addressStateError"
                                            :required="true"
                                            @state-selected="$v.address.state.$model = $event"
                                    ></usStatesSelect>
                                </v-col>
                                <v-col cols="12" md="4" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            v-model="$v.address.zip_code.$model"
                                            label="Zip Code"
                                            :error-messages="addressZipError"
                                            error-count=2
                                            required
                                            v-mask="masks.zipCode"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            v-model="$v.editedItem.guardian_email.$model"
                                            label="Guardian Email"
                                            :error-messages="emailError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" pa-1 ma-1>
                                    <v-text-field
                                            outlined
                                            v-model="$v.editedItem.guardian_phone_number.$model"
                                            label="Guardian Phone"
                                            :error-messages="phoneError"
                                            error-count=2
                                            required
                                            v-mask="masks.phoneMask"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">Cancel</v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">{{ editedIndex !== '-1' ? 'Save' : 'Next'}}</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="okCall($event)">
        </dialog-alert>
<!--        <dialog-alert :text="notFoundError"-->
<!--                      :alert-type="alertTypes.ERROR"-->
<!--                      :open="openNotFound"-->
<!--                      @alert-closed="close()">-->
<!--        </dialog-alert>-->
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {required, minLength,email,numeric} from 'vuelidate/lib/validators';
    import {Client} from '@/shared/dtos/Dtos';
    const datePicker = () => import( '@/components/common/DatePicker');
    import {TOKEN} from '@/shared/enums/TokenSeparator';
    import {FORM_STATUS } from '@/shared/enums/FormStatuses';
    const DialogAlert = () => import( '@/components/common/DialogAlert');
    import {formUnsavedMixin} from "@/shared/mixins/FormUnsaved";
    import { ALPHA_WITH_SPACES_VALIDATOR, ALPHA_NUMERIC_WITH_SPACES_VALIDATOR } from "@/shared/validators/Validators";
    const usStatesSelect = () => import( '@/components/common/UsStatesSelect');
    import {EMPLOYEE_CLIENT_STATUS} from '@/shared/enums/EntitiesStatus';
    import {WRONG_ID_SUPPLIED}  from "@/shared/enums/AlertTexts";
    import {ALERT_TYPES} from "@/shared/enums/AlertTexts";
    import {CLIENT_ACTIONS} from "@/shared/enums/Client";

    export default {
        name: "clientForm",
        props:['id'],
        components:{
            datePicker, DialogAlert, usStatesSelect
        },
        mixins:[formUnsavedMixin],
        data(){
            return {
                address: {
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zip_code:''
                },
                editedItem: {...Client},
                editedIndex: '-1',
                clientTypes: [],
                isSaving: false,
                masks:{
                    phoneMask: "##########",
                    zipCode: "#####"
                },
                alertTypes: ALERT_TYPES
            };
        },
        validations: {
            address: {
                address_line_1: {
                    required
                },
                address_line_2: {
                    numeric
                },
                city: {
                    required,
                    ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
                },
                state: {
                    required
                },
                zip_code: {
                    required,
                    numeric
                }
            },
            editedItem:{
                name: {
                    required,
                    minLength: minLength(2),
                    ALPHA_WITH_SPACES_VALIDATOR
                },
                guardian_name: {
                    required,
                    minLength: minLength(2),
                    ALPHA_WITH_SPACES_VALIDATOR
                },
                family_name: {
                    required,
                    ALPHA_WITH_SPACES_VALIDATOR
                },
                birthdate: {
                    required
                },
                guardian_email: {
                    required,
                    email: email
                },
                guardian_phone_number: {
                    required,
                    numeric
                },
            }
        },
        computed:{
            guardianNameError(){
                const errors = []
                if (!this.$v.editedItem.guardian_name.$dirty) {
                    return errors
                }

                !this.$v.editedItem.guardian_name.minLength && errors.push('Guardian Name must be at least '+
                    this.$v.editedItem.guardian_name.$params.minLength.min +' characters long')
                !this.$v.editedItem.guardian_name.required && errors.push('Guardian Name is required.')
                !this.$v.editedItem.name.ALPHA_WITH_SPACES_VALIDATOR && errors.push('Name must contains only letters')
                return errors
            },
            nameError(){
                const errors = []
                if (!this.$v.editedItem.name.$dirty) {
                    return errors
                }

                !this.$v.editedItem.name.minLength && errors.push('Name must be at least '+
                    this.$v.editedItem.name.$params.minLength.min +' characters long')
                !this.$v.editedItem.name.required && errors.push('Name is required.')
                !this.$v.editedItem.name.ALPHA_WITH_SPACES_VALIDATOR && errors.push('Name must contains only letters')
                return errors
            },
            lastNameError(){
                const errors = []
                if (!this.$v.editedItem.family_name.$dirty) {
                    return errors
                }

                !this.$v.editedItem.family_name.required && errors.push('Last name is required.')
                !this.$v.editedItem.family_name.ALPHA_WITH_SPACES_VALIDATOR && errors.push('Family name must contains only letters')

                return errors
            },
            dobError(){
                const errors = []
                if (!this.$v.editedItem.birthdate.$dirty) {
                    return errors
                }

                !this.$v.editedItem.birthdate.required && errors.push('DOB is required.')
                return errors
            },
            addressError(){
                const errors = []
                if (!this.$v.address.address_line_1.$dirty) {
                    return errors
                }

                !this.$v.address.address_line_1.required && errors.push('Address is required.')
                return errors
            },
            addressCityError(){
                const errors = []
                if (!this.$v.address.city.$dirty) {
                    return errors
                }

                !this.$v.address.city.required && errors.push('City is required.')
                !this.$v.address.city.ALPHA_NUMERIC_WITH_SPACES_VALIDATOR && errors.push('City must contains only letters and numbers')

                return errors
            },
            addressStateError(){
                const errors = []
                if (!this.$v.address.state.$dirty) {
                    return errors
                }

                !this.$v.address.state.required && errors.push('State is required.')
                return errors
            },
            addressZipError(){
                const errors = []
                if (!this.$v.address.zip_code.$dirty) {
                    return errors
                }

                !this.$v.address.zip_code.required && errors.push('Zip Code is required.')
                return errors
            },
            emailError(){
                const errors = []
                if (!this.$v.editedItem.guardian_email.$dirty) {
                    return errors
                }

                !this.$v.editedItem.guardian_email.email && errors.push('A valid email address is required')
                !this.$v.editedItem.guardian_email.required && errors.push('Email address is required.')
                return errors
            },
            phoneError(){
                const errors = []
                if (!this.$v.editedItem.guardian_phone_number.$dirty) {
                    return errors
                }
                !this.$v.editedItem.guardian_phone_number.required && errors.push('Phone number is required.')
                return errors
            }
         },
        methods:{
            async initialize() {
                this.editedItem.status = EMPLOYEE_CLIENT_STATUS.UPDATE_REQUIRED.status;

                if(this.id !== undefined)
                {
                    await this.$store.dispatch('getClient',{id: this.id});
                    this.editedItem = this.$store.getters.getClient;

                    if(!this.editedItem.hasOwnProperty('id')) {
                        this.alertType = ALERT_TYPES.ERROR;
                        this.alertText = WRONG_ID_SUPPLIED;
                        this.okCall = () => this.close();
                        this.openAlert = true;
                        return;
                    }
                    else {
                        this.editedItem.guardian_phone_number = this.editedItem.guardian_phone_number.replace(/\+1/,'');
                        this.address = this.editedItem.address;
                    }
                }
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;
                this.$router.push({name: 'clientTable'});
            },
            resetValues(){
                this.$v.$reset();
                this.client = {...Client};
                this.$store.commit('setClient',null);
            },
            async save(){
                this.$v.$touch();
                if(this.$v.$anyError)
                    return;

                this.isSaving = true;

                try
                {
                    let address = {
                        address_line_1: this.address.address_line_1,
                        address_line_2: this.address.address_line_2,
                        city:           this.address.city,
                        state:          this.address.state,               // province also valid
                        zip_code:       this.address.zip_code,            // postal_code also valid
                        country:        'United States'
                    };
                    this.editedItem.address = address;
                    this.editedItem.guardian_phone_number = '+1'+this.editedItem.guardian_phone_number;

                    await this.$store.dispatch('setClient',this.editedItem);
                    /**
                     * Updating list of Employees
                     */
                        this.$store.commit('setClients', []);
                }
                catch (e)
                {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.status = FORM_STATUS.SAVE;
                if(this.id === undefined){
                    this.$router.push({name: CLIENT_ACTIONS.ADD_DOCUMENTS.route});
                }
                else {
                    this.close();
                }
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>